import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { Styles as S } from '~/pages/history/multipleChoice/studyGoal/styles'
import { OptionType } from '~/shared/constants/commonConstants'
import { useDelayedContinue } from '~/shared/hooks/useDelayedContinue'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

const QUESTION = 'What method works best for you when learning new things?'

const OPTIONS = [
  { key: 'theoryFirst', i18nKey: 'first' },
  { key: 'dependsOnSubject', i18nKey: 'second' },
  { key: 'practiceFirst', i18nKey: 'third' },
] as const

const BestMethod = ({ nextPagePath, pageId }: TPageProps) => {
  const { t } = useTranslation('history')
  const [answer, setAnswer] = useState('')
  const { isAnswersDisabled, handleChange, setIsAnswersDisabled } =
    useDelayedContinue()

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: QUESTION,
  })

  return (
    <S.Root>
      <S.StyledContainer>
        <S.ScrollContent>
          <S.Content>
            <S.Title>
              <Trans
                ns="history"
                i18nKey="onboarding.historyBestMethod.title"
              />
            </S.Title>
          </S.Content>

          {OPTIONS.map(({ key, i18nKey }) => {
            const optionText = t(
              `onboarding.historyBestMethod.options.${i18nKey}`,
            )
            const spaceIndex = optionText.indexOf(' ')
            const emoji =
              spaceIndex !== -1 ? optionText.slice(0, spaceIndex) : optionText
            const text =
              spaceIndex !== -1 ? optionText.slice(spaceIndex + 1) : ''

            return (
              <S.StyledOption
                key={key}
                type={OptionType.RADIO}
                value={key}
                name="bestMethod"
                disabled={isAnswersDisabled}
                checked={answer === key}
                onChange={(optionValue) => {
                  setAnswer(optionValue)
                  setIsAnswersDisabled(true)
                  handleChange(optionValue, handleContinue)
                }}
              >
                <S.Value>
                  <S.OptionIcon>{emoji}</S.OptionIcon>
                  <S.ValueText>{text}</S.ValueText>
                </S.Value>
              </S.StyledOption>
            )
          })}
        </S.ScrollContent>
      </S.StyledContainer>
    </S.Root>
  )
}

export default BestMethod
